import {useTranslation} from "ni18n";
import React from "react";
import {V5Img} from "src/components/_common/Carbon";
import Fade from "../Transitions/Fade";
import {Btn} from "../V5Comp";
import {SubmitStatus} from "./SalesforceForm";

type Props = {
  error: boolean;
  setSubmitStatus: (value: React.SetStateAction<SubmitStatus>) => void;
};

const SalesforceFormSuccess: React.FC<Props> = ({error, setSubmitStatus}) => {
  const i18n = useTranslation();

  const header = error ? i18n.t("Something went wrong.") : i18n.t("Thank you!");
  const text = error
    ? i18n.t("Thank you for your patience! Please try again.")
    : i18n.t(
        "We’ll get back to you within one business day. In the meantime, explore employer resources from our Chief Medical Officer Sujal Mandavia.",
      );

  const resetSubmitStatus = () => {
    setSubmitStatus("not-submitted");
  };

  return (
    <div className="pos-r oh p8 pb40 pb30-xs">
      <Fade in appear>
        <div className="fs28 fs32-sm font-cb mb4">{header}</div>
        <p className="fs24 fs24-sm font-cm gray800 ">{text}</p>
        {error && (
          <Btn
            aria-label={i18n.t("Click to go back to the submission form and try again.")}
            className="mt8 focus-bsDarkBlue3 event-Yd9g9c mr1"
            onClick={resetSubmitStatus}
          >
            {i18n.t("Go Back")}
          </Btn>
        )}
        <Btn
          className="focus-bsDarkBlue3 mt8"
          href="https://www.youtube.com/playlist?list=PLu-GZsDFusNbZFeTN8m7RNOtGu5n7Yv4g"
        >
          {i18n.t("Watch the Playlist")}
          <span className="cIcon-arrow-45deg fs10 ml3" />
        </Btn>
      </Fade>
      <V5Img src={`/illustrations/squiggly-lines-yellow-2.jpg`} className="pos-a bottom0 right0" />
    </div>
  );
};

export default SalesforceFormSuccess;
